import OBase from './OBase';

import * as Geometry from '../geometry';

export default class StreamGate extends OBase {
  update () {
    let sInputTree = this.getObjectInput('Stream');
    let gInputTree = this.getFloatInput('Gate');

    let count = 0;
    let outputList = [];

    while (true) {
      const outputName = 'Target ' + count.toString();
      // eslint-disable-next-line use-isnan
      if (!(outputName in this.outputs) || this.outputs[outputName].paramObject === NaN) {
        break;
      } else {
        let genericObject = this.outputs[outputName].paramObject;
        outputList.push(genericObject);
        count++;
      }
    }

    let gValue = gInputTree.branches[0][0];
    let sValue = sInputTree.branches[0][0];

    // var sOutput = outputList[gValue % outputList.length]
    // console.log(gValue, outputList.length)

    for (let i = 0; i < outputList.length; i++) {
      if (i === gValue) {
        outputList[i].value = sInputTree;
      } else {
        if (sValue instanceof THREE.Geometry) {
          var tree = new Geometry.DataTree();
          tree.add(new Geometry.GHGeometry(), new Geometry.GHPath(0));
          outputList[i].value = tree;
        } else {
          outputList[i].value = NaN;
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/StreamGate.js